import React from "react";
import "./Footer.css";
import { useState } from "react";
import Modal from "../Modal/Modal";
import PopupForm from "../PopupForm/PopupForm";

const Footer = () => {
  const [open, setOpen] = useState(false);
  return (
    <footer className="footer">
      <div className="container">
        <nav className="fixed-bottom">
          <div className="bottom-div">
            <div className="starting_price">
              <a href="tel:9999063322">9999063322</a>
            </div>
            <button
              className="btn btn--primary btn--lg footer-btn"
              onClick={() => setOpen(true)}
            >
              Enquire Now
            </button>
          </div>
        </nav>
        <div className="footer-content">
          {/* Left Column - Buy Apartment in Digi Homes */}
          <div className="footer-column">
            <h3 className="footer-title">Buy Property in Emaar</h3>
            <ul className="footer-links">
              <li>
                <a
                  href="https://emaargurgaon.com/buy-emaar-amaris-sector-62-gurgaon/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Emaar Amaris
                </a>
              </li>
              <li>
                <a
                  href="https://www.emaargurgaon.com/emaar-digi-homes-sector-62-gurgaon/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Emaar Digi Homes
                </a>
              </li>
              <li>
                <a
                  href="https://www.emaargurgaon.com/buy-emaar-mgf-marbella-villas-sector-66-gurgaon/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Emaar Marbella Villas
                </a>
              </li>
              <li>
                <a
                  href="https://www.emaargurgaon.com/buy-emaar-mgf-palm-drive-sector-65-gurgaon/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Emaar Palm Drive
                </a>
              </li>
              <li>
                <a
                  href="https://www.emaargurgaon.com/buy-emaar-mgf-emerald-estate-sector-65-gurgaon/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Emaar Emerald Estate
                </a>
              </li>
              <li>
                <a
                  href="https://www.emaargurgaon.com/buy-emaar-mgf-emerald-floors-sector-65-gurgaon/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Emaar Emerald Floors
                </a>
              </li>
            </ul>
          </div>

          {/* Middle Column - Buy Property in Gurgaon */}
          <div className="footer-column">
            <h3 className="footer-title">Buy Property in Ireo Projects</h3>
            <ul className="footer-links">
              <li>
                <a
                  href="https://ireoprojects.co.in/ireo-the-corridors/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Ireo Corridors
                </a>
              </li>
              <li>
                <a
                  href="https://ireoprojects.co.in/ireo-plots/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Ireo Plots
                </a>
              </li>
              <li>
                <a
                  href="https://ireoprojects.co.in/ireo-skyon/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Ireo Skyon
                </a>
              </li>
              <li>
                <a
                  href="https://ireoprojects.co.in/ireo-victory-valley/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Ireo Victory Valley
                </a>
              </li>
              <li>
                <a
                  href="https://ireoprojects.co.in/ireo-grand-arch/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Ireo Grand Arch
                </a>
              </li>
              <li>
                <a
                  href="https://ireoprojects.co.in/ireo-city-central/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Ireo City Central
                </a>
              </li>
            </ul>
          </div>

          {/* Right Column - Contact Us */}
          <div className="footer-column">
            <h3 className="footer-title">Contact us</h3>
            <div className="contact-info-section">
              <p className="contact-description">
                To know more about Ansal Esencia, call our expert
              </p>
              <div className="contact-details">
                <div className="contact-item">
                  <strong>Call us : +91 9999 06 3322</strong>
                </div>
                <div className="contact-item">
                  <strong>Email us : info@atulgupta.in</strong>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Contact Bar */}
        <div className="footer-bottom-contact">
          <div className="bottom-contact-item">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
            </svg>
            <a href="tel:+919999063322">+91 9999 06 3322</a>
          </div>
          <div className="bottom-contact-item">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
              <polyline points="22,6 12,13 2,6" />
            </svg>
            <a href="mailto:info@atulgupta.in">info@atulgupta.in</a>
          </div>
        </div>

        {/* Copyright */}
        <div className="footer-copyright">
          <p>Copyright © 2019-2025 | www.ansalesencia.com</p>
        </div>
        <Modal
          open={open}
          onClose={() => setOpen(false)}
          ariaLabel="Ansal Esencia enquiry form"
        >
          <PopupForm />
        </Modal>
      </div>
    </footer>
  );
};

export default Footer;
